const initializeTourGalleries = function(scope = document) {
    const galleries = scope.querySelectorAll('.tour-gallery:not([data-gallery-initialized])');

    galleries.forEach(function(block) {
        if (block.closest('.editor-styles-wrapper')) {
            block.dataset.galleryInitialized = 'true';
            return;
        }

        const items = Array.from(block.querySelectorAll('.gallery-item'));
        const modal = block.querySelector('.modal');

        if (!items.length || !modal) {
            return;
        }

        const image = modal.querySelector('.modal-content img');
        const title = modal.querySelector('.modal-title');
        const size = modal.querySelector('.modal-size');
        const counter = modal.querySelector('.modal-counter');
        const closeButton = modal.querySelector('.modal-close');
        const previousButton = modal.querySelector('.modal-previous');
        const nextButton = modal.querySelector('.modal-next');
        let currentIndex = 0;
        let lastFocusedElement = null;
        let touchStartX = 0;

        const showImage = function(index) {
            currentIndex = (index + items.length) % items.length;
            image.src = items[currentIndex].dataset.fullImage;
            image.alt = items[currentIndex].dataset.alt;
            title.textContent = items[currentIndex].dataset.title;
            size.textContent = items[currentIndex].dataset.size;
            counter.textContent = `${currentIndex + 1} / ${items.length}`;
        };

        const openModal = function(index, trigger) {
            lastFocusedElement = trigger;
            showImage(index);
            modal.classList.add('is-open');
            modal.setAttribute('aria-hidden', 'false');
            document.body.classList.add('tour-gallery-modal-open');
            closeButton.focus();
        };

        const closeModal = function() {
            modal.classList.remove('is-open');
            modal.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('tour-gallery-modal-open');
            image.src = '';

            if (lastFocusedElement) {
                lastFocusedElement.focus();
            }
        };

        items.forEach(function(item, index) {
            item.addEventListener('click', function() {
                openModal(index, item);
            });
        });

        closeButton.addEventListener('click', closeModal);
        previousButton.addEventListener('click', function() {
            showImage(currentIndex - 1);
        });
        nextButton.addEventListener('click', function() {
            showImage(currentIndex + 1);
        });

        modal.addEventListener('click', function(event) {
            if (event.target === modal) {
                closeModal();
            }
        });

        modal.addEventListener('touchstart', function(event) {
            touchStartX = event.changedTouches[0].screenX;
        }, { passive: true });

        modal.addEventListener('touchend', function(event) {
            const distance = event.changedTouches[0].screenX - touchStartX;

            if (Math.abs(distance) < 50) {
                return;
            }

            showImage(distance > 0 ? currentIndex - 1 : currentIndex + 1);
        }, { passive: true });

        modal.addEventListener('keydown', function(event) {
            if (event.key === 'Escape') {
                closeModal();
            }

            if (event.key === 'ArrowLeft') {
                showImage(currentIndex - 1);
            }

            if (event.key === 'ArrowRight') {
                showImage(currentIndex + 1);
            }

            if (event.key === 'Tab') {
                const controls = [closeButton, previousButton, nextButton];
                const position = controls.indexOf(document.activeElement);

                if (event.shiftKey && position === 0) {
                    event.preventDefault();
                    controls[controls.length - 1].focus();
                } else if (!event.shiftKey && position === controls.length - 1) {
                    event.preventDefault();
                    controls[0].focus();
                }
            }
        });

        block.dataset.galleryInitialized = 'true';
    });
};

document.addEventListener('DOMContentLoaded', function() {
    initializeTourGalleries();
});

if (window.acf) {
    window.acf.addAction('render_block_preview/type=tour-gallery', function(block) {
        initializeTourGalleries(block[0] || block);
    });
}
